import { Helmet } from "react-helmet";
import {
  Box,
  Container,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
  Paper,
  TableContainer,
  Typography,
  Button,
  Modal,
} from "@material-ui/core";
import UserblockListResults from "src/components/userblock/userblocklist";
import { makeStyles } from "@material-ui/core/styles";
import React, { useState, useEffect } from "react";
import axios from "axios";
import { DELETE_NTF_API, GET_COLLECTIBLE_API } from "../../apiContants";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
    fontSize: "20px",
  },
  blocked: {
    position: "relative",
    right: "0px",
  },
  options: {
    width: "120px!important",
  },
  mui: {
    border: "1px!important",
    color: "red!important",
    paddingTop: "15px!important",
    paddingLeft: "0px!important",
    justifyContent: "flex-start",
    display: "flex",
  },
  mui1: {
    border: "1px!important",
    color: "red!important",
    paddingTop: "15px!important",
    paddingLeft: "0px!important",
    justifyContent: "flex-start",
    display: "flex",
    paddingLeft: "20px!important",
  },
}));
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};
const DeleteNFT = () => {
  const classes = useStyles();
  const [addressId, setAddressId] = useState(null);
  const [listCollect, setListCollect] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [page, setPage] = useState(0);
  const [openAlert, setOpenAlert] = useState(false);

  const handleLimitChange = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handlePageChange = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeForm = (address) => (event) => {
    if (event.target.value) {
      setAddressId(event.target.value);
    }
  };
  const Delete = async () => {
    if (addressId) {
      const WalletAddress = await axios.delete(
        DELETE_NTF_API + addressId.toString()
      );
      if (WalletAddress?.length === 0) {
        setOpenAlert(true);
        GetData();
      }
    }
  };
  const GetData = async () => {
    const WalletAddress = await axios.get(GET_COLLECTIBLE_API);
    if (WalletAddress) {
      setListCollect(WalletAddress.data.collectibles);
    }
  };
  useEffect(() => {
    GetData();
  }, []);
  const AlertNotice = (
    <>
      <Box sx={style}>
        <Typography id="modal-modal-title" variant="h6" component="h2">
          Alert
        </Typography>
        <Typography id="modal-modal-description" sx={{ mt: 2 }}>
          <span>Delete Success !</span>
        </Typography>
        <Typography id="modal-modal-footer" sx={{ mt: 2 }}>
          <Button
            className="cancel_button"
            color="primary"
            variant="contained"
            style={{ float: "right" }}
            onClick={() => setOpenAlert(false)}
          >
            Close
          </Button>
        </Typography>
      </Box>
    </>
  );
  return (
    <Box
      sx={{
        backgroundColor: "background.default",
        minHeight: "100%",
        py: 3,
      }}
    >
      <Container maxWidth="lg">
        <Card>
          <CardHeader title="Delete NFT" />
          <Divider />
          <CardContent>
            <Grid container spacing={3}>
              <Grid className={classes.mui} item xs={3}>
                <span className={classes.paper}>ID</span>
              </Grid>
              <Grid className={classes.mui} item xs={5}>
                <TextField
                  onChange={handleChangeForm("address")}
                  className="containt"
                  placeholder="enter ID"
                  inputProps={{
                    min: 0,
                    style: { textAlign: "center", width: "250px" },
                  }}
                  id="standard-basic"
                />
              </Grid>

              <Grid className={classes.mui1} item xs={2}>
                <button
                  className={classes.options}
                  type="button"
                  onClick={() => Delete()}
                >
                  Delete
                </button>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
        <Box sx={{ pt: 3 }}>
          <Divider />
          <Box sx={{ minWidth: 1050 }}>
            <Paper sx={{ width: "100%", mb: 2 }}>
              <TableContainer>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>ID</TableCell>
                      <TableCell>Title</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {listCollect
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((customer) => (
                        <TableRow
                          hover
                          key={customer.id}
                          // selected={selectedCustomerIds.indexOf(customer.id) !== -1}
                        >
                          <TableCell>{customer.id}</TableCell>

                          <TableCell>{customer.title}</TableCell>
                        </TableRow>
                      ))}
                  </TableBody>
                </Table>
              </TableContainer>
              {/* </ExcelExport> */}

              <TablePagination
                component="div"
                count={listCollect.length}
                onChangePage={handlePageChange}
                onRowsPerPageChange={handleLimitChange}
                page={page}
                rowsPerPage={rowsPerPage}
                rowsPerPageOptions={[5]}
              />
            </Paper>
          </Box>
        </Box>
        <Modal
          open={openAlert}
          onClose={() => setOpenAlert(false)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          {AlertNotice}
        </Modal>
      </Container>
    </Box>
  );
};

export default DeleteNFT;
